/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChildBirth } from './ChildBirth';
import {
    ChildBirthFromJSON,
    ChildBirthFromJSONTyped,
    ChildBirthToJSON,
} from './ChildBirth';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface ChildBirthPagination
 */
export interface ChildBirthPagination {
    /**
     * 
     * @type {Array<ChildBirth>}
     * @memberof ChildBirthPagination
     */
    data?: Array<ChildBirth>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ChildBirthPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the ChildBirthPagination interface.
 */
export function instanceOfChildBirthPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChildBirthPaginationFromJSON(json: any): ChildBirthPagination {
    return ChildBirthPaginationFromJSONTyped(json, false);
}

export function ChildBirthPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildBirthPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ChildBirthFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function ChildBirthPaginationToJSON(value?: ChildBirthPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ChildBirthToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

